import { IGatsbySvg } from "@bond-london/gatsby-transformer-extracted-svg";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";

export const ImageBlock: React.FC<{
  image?: IGatsbyImageData | null;
  shape?: IGatsbySvg | null;
  alt?: string | null;
  fullWidth?: boolean | null;
}> = ({ image, alt, fullWidth, shape }) => {
  if (!image && !shape) return null;
  if (fullWidth) {
    return (
      <section
        data-component="Image Block Full"
        className="my-section aspect-h-650 aspect-w-1440 w-full"
      >
        {image && (
          <GatsbyImage
            objectFit="cover"
            objectPosition="center"
            style={{ position: "absolute" }}
            image={image}
            alt={alt ?? "Image"}
          />
        )}
        {shape && (
          <img
            src={shape.encoded ?? shape.encodedUrl}
            alt={alt ?? "Image"}
            className="absolute"
          />
        )}
      </section>
    );
  }

  return (
    <section data-component="Image Block" className="py-section relative">
      {image && (
        <GatsbyImage
          className="h-full w-full"
          image={image}
          alt={alt ?? "Image"}
          objectFit="cover"
          objectPosition="center"
        />
      )}
      {shape && (
        <img
          src={shape.encoded ?? shape.encodedUrl}
          alt={alt ?? "Image"}
          className="object-cover object-center"
        />
      )}
    </section>
  );
};
